module.exports = {
  countries: (Api) ->
    Api.Country.query().$promise
}
